(ns capra.pipeline
  "Client-side pipeline building and result resolution."
  (:require
   [capra.context :as ctx]
   [capra.lifecycle :as lifecycle]
   [capra.stub :as stub]
   [capra.protocol :as proto]
   [clojure.walk :as walk]))

(defn build-pipeline
  "Run user-fn with a fresh recording context.
   Returns {:ops [...] :return-val <raw return value with PendingRefs>}."
  [user-fn]
  (let [pipeline-ctx (ctx/make-pipeline-ctx)
        return-val   (user-fn pipeline-ctx)
        ops          @(:ops-atom pipeline-ctx)]
    {:ops ops :return-val return-val}))

(defn extract-return-refs
  "Walk return-val collecting all PendingRef op-ids.
   Returns a set of op-ids that the server should include in :results."
  [return-val]
  (let [refs (atom #{})]
    (walk/postwalk
     (fn [x]
       (when (ctx/pending-ref? x)
         (swap! refs conj (:op-id x)))
       x)
     return-val)
    @refs))

(defn- maybe-wrap-cap
  "If a value is a #rpc/cap record, convert to CapraStub and register.
   Recursively walks the result."
  [v cap-advertisements]
  (let [cap-map (into {} (map (fn [adv] [(:id adv) adv])) cap-advertisements)]
    (walk/postwalk
     (fn [x]
       (if (proto/cap? x)
         (if-let [adv (get cap-map (:id x))]
           (let [s (stub/cap->stub adv)]
             (lifecycle/register-stub! s)
             s)
           ;; No advertisement — create a minimal stub
           (let [s (stub/->CapraStub (:id x) nil nil nil)]
             (lifecycle/register-stub! s)
             s))
         x))
     v)))

(defn resolve-results
  "Given a server response, reconstruct the return-val shape
   by substituting PendingRefs with actual results."
  [response return-val]
  (let [{:keys [results caps]} response
        cap-adverts (or caps [])]
    (walk/postwalk
     (fn [x]
       (if (ctx/pending-ref? x)
         (let [raw (get results (:op-id x))]
           (maybe-wrap-cap raw cap-adverts))
         x))
     return-val)))
